/*----------------------------------
- PRODUCT ORIGIN
----------------------------------*/

export const resolveProductOrigin = (configuredOrigin: string): string => {
    const url = new URL(configuredOrigin);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        throw new Error('The configured product origin must use HTTP or HTTPS.');
    }
    if (url.origin !== configuredOrigin.replace(/\/$/, '')) {
        throw new Error('The configured product origin must not contain a path, query, or fragment.');
    }
    return url.origin;
};
